define('view/campaign-manager/campaign-manager.page.view',['require','exports','module','underscore','blockit','uikit/uikit','marionette'],function(require, exports, module) {
  // prettier-ignore
  var _       = require('underscore'),
      BlocKit = require('blockit'),
      UIKit   = require('uikit/uikit'),
      Mn      = require('marionette');

  //TODO: Do we need to put it in the behaviors folder permanently? Maybe even add it to BlocKit?
  var BindDropdownValueToModelBehavior = Mn.Behavior.extend({
    onFirstRender: _.debounce(function() {
      this.determineSelectedDropdownValue();
      this.listenTo(this.view.model, 'sync', this.determineSelectedDropdownValue);
      this.listenTo(this.view, 'change:value', this.syncSelectedValueToModel);
    }),

    determineSelectedDropdownValue: function() {
      var model = this.view.model;
      var selectedDropdownValue;
      var bindingAttribute = this.view.bindings.value;
      if (bindingAttribute == null) {
        throw new Error('Expected non-null bindings.value attribute on the view');
      }
      var currentModelValue = model.get(bindingAttribute);
      if (currentModelValue == null) {
        return;
      }
      this.view.collection.each(function(dropdownValueModel) {
        var bindingValueId = dropdownValueModel.get('id');
        if (currentModelValue.id === bindingValueId) {
          selectedDropdownValue = dropdownValueModel;
        }
      });
      this.view.value = selectedDropdownValue;
    },

    syncSelectedValueToModel: function(view, selectedModel) {
      var bindingAttribute = view.bindings.value;
      if (bindingAttribute == null) {
        throw new Error('Expected non-null bindings.value attribute on the view.');
      }
      if (selectedModel) {
        this.view.model.set(bindingAttribute, selectedModel);
        view.model.set(bindingAttribute, selectedModel);
      }
    },
  });

  var CampaignManagerView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      modals: {},
      root: {
        type: BlocKit.FullWidthLayoutView,
        model: '@resources.campaignManagerModel',
        pageHeader: {
          headerText: 'Disclosure Campaign Manager',
          actions: [],
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.FormContainerView,
              model: '@resources.campaignManagerModel',
              components: [
                {
                  type: UIKit.Header,
                  text: 'Annual Campaign Period',
                  tagName: 'h4',
                },
                {
                  type: BlocKit.FormContainerView.RowView,
                  className: 'campaign-period-row',
                  components: [
                    {
                      name: 'campaignStartDateInput',
                      label: {
                        text: 'Start Date',
                      },
                      content: {
                        type: UIKit.InputDate,
                        calendarTimeSelector: 'endOfDay',
                        format: 'MM/DD/YYYY', //use moment.js date format strings
                        model: '@resources.campaignManagerModel',
                        bindings: {
                          value: 'campaignStartDate',
                        },
                        behaviors: {
                          BindAndFormatOptionValuesBehavior: {
                            optionValues: {
                              visible: {},
                            },
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                          },
                        },
                        className: 'input-box',
                      },
                    },
                    {
                      name: 'campaignEndDateInput',
                      label: {
                        text: 'End Date',
                      },
                      content: {
                        type: UIKit.InputDate,
                        calendarTimeSelector: 'endOfDay',
                        format: 'MM/DD/YYYY', //use moment.js date format strings
                        model: '@resources.campaignManagerModel',
                        bindings: {
                          value: 'campaignEndDate',
                        },
                        className: 'input-box',
                      },
                    },
                  ],
                },
                {
                  type: UIKit.Header,
                  text: 'Reminder Emails',
                  tagName: 'h4',
                },
                {
                  type: BlocKit.FormContainerView.RowView,
                  className: 'campaign-period-row reminder-dropdown',
                  components: [
                    {
                      name: 'campaignPeriodReminderDropDown',
                      label: {
                        text: 'Campaign Period',
                      },
                      className: 'field input-box',
                      content: {
                        type: UIKit.Dropdown,
                        childBindings: {
                          text: 'displayName',
                        },
                        collection: '@resources.CampaignPeriodCollection',
                        model: '@resources.campaignManagerModel',
                        bindings: {
                          value: 'reminder_frequency',
                        },
                        behaviors: {
                          BindDropdownValueToModelBehavior: {
                            behaviorClass: BindDropdownValueToModelBehavior,
                          },
                        },
                      },
                    },
                  ],
                },
                {
                  type: BlocKit.FormContainerView.RowView,
                  className: 'campaign-period-row reminder-dropdown',
                  components: [
                    {
                      name: 'campaignFinalWeekReminderDropDown',
                      label: {
                        text: 'Final Week of Campaign',
                      },
                      className: 'field input-box',
                      content: {
                        type: UIKit.Dropdown,
                        childBindings: {
                          text: 'displayName',
                        },
                        collection: '@resources.FinalizedCollection',
                        model: '@resources.campaignManagerModel',
                        bindings: {
                          value: 'reminder_frequency_final_period_of_campaign',
                        },
                        behaviors: {
                          BindDropdownValueToModelBehavior: {
                            behaviorClass: BindDropdownValueToModelBehavior,
                          },
                        },
                      },
                    },
                  ],
                },
                {
                  type: BlocKit.FormContainerView.RowView,
                  className: 'campaign-period-row reminder-dropdown',
                  components: [
                    {
                      name: 'pastDueReminderDropDown',
                      label: {
                        text: 'Past Due',
                      },
                      className: 'field input-box',
                      content: {
                        type: UIKit.Dropdown,
                        childBindings: {
                          text: 'displayName',
                        },
                        collection: '@resources.FinalizedCollection',
                        model: '@resources.campaignManagerModel',
                        bindings: {
                          value: 'reminder_frequency_past_due',
                        },
                        behaviors: {
                          BindDropdownValueToModelBehavior: {
                            behaviorClass: BindDropdownValueToModelBehavior,
                          },
                        },
                      },
                    },
                  ],
                },
                {
                  type: BlocKit.FormContainerView.RowView,
                  components: [
                    {
                      name: 'saveButton',
                      content: {
                        type: UIKit.Button,
                        model: '@resources.campaignManagerModel',
                        text: 'Save',
                        icon: 'save',
                        color: 'primary',
                        behaviors: {
                          InvokeModelMethodOnEventBehavior: {
                            method: 'save',
                            showLoading: true,
                            onMethodSuccessEvent: 'saved:campaignManagerModel',
                            behaviorClass: BlocKit.InvokeModelMethodOnEventBehavior,
                          },
                          EnableOnlyOnUnsavedChangesBehavior: {
                            model: '@resources.campaignManagerModel',
                            behaviorClass: BlocKit.EnableOnlyOnUnsavedChangesBehavior,
                          },
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        }, //end of contentColumn
      },
    },
  });

  module.exports = CampaignManagerView;
});

